
$(() => {
  const duration = 200;
  const generalPostSection = $('.general-post-section');
  const filterElement = generalPostSection.find('.general-post-type-wrapper > .ct-text-block');
  if (generalPostSection.length == 0) {
    return;
  }

  filterElement.on('click', (e) => {
    e.stopPropagation();
    const $this = $(e.target);
    const filterWrapper = $this.parent();
    filterElement
      .parent()
      .not(filterWrapper)
      .removeClass('filter-expanded')
      .find('.facetwp-type-radio')
      .slideUp(duration);

    const isExpanded = filterWrapper.hasClass('filter-expanded');
    if (isExpanded) {
      filterWrapper.removeClass('filter-expanded');
      filterWrapper.find('.facetwp-type-radio').slideUp(duration);
    } else {
      filterWrapper.addClass('filter-expanded');
      filterWrapper.find('.facetwp-type-radio').slideDown(duration);
    }
  });

  $('body').on('click', () => {
    const winWidth = document.documentElement.clientWidth;
    if (winWidth < 992) {
      filterElement.parent().removeClass('filter-expanded');
      filterElement.parent().find('.facetwp-type-radio').slideUp(duration);
    }
  });
});
